// src/components/landing/ClaimSalonModal.jsx
import React, { useEffect, useRef } from "react";

const ClaimSalonModal = ({ open, onClose, slug, claimUrl, onGoToSalon }) => {
  const primaryBtnRef = useRef(null);
  const salonUrl = slug ? `${window.location.origin}/${slug}` : "";

  // 👇 SIEMPRE se llama el hook. Si está cerrado, el efecto no hace nada.
  useEffect(() => {
    if (!open) return; // no configuramos nada si está cerrado
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => primaryBtnRef.current?.focus(), 30);
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
      clearTimeout(t);
    };
  }, [open, onClose]);

  // 👇 recien acá corto el render si está cerrado
  if (!open) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(salonUrl); } catch { }
  };

  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog" aria-modal="true" onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg rounded-2xl bg-white shadow-2xl ring-1 ring-black/5 animate-[modin_.18s_ease-out]"
        style={{ animation: "modin .18s ease-out" }}
      >
        <style>{`
          @keyframes modin {
            from { opacity:0; transform: translateY(8px) scale(.98); }
            to   { opacity:1; transform: translateY(0) scale(1); }
          }
        `}</style>

        <div className="px-6 py-5 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold text-slate-900">¡Espacio creado!</h3>
          <button onClick={onClose} className="p-2 rounded-md text-slate-500 hover:bg-slate-100" aria-label="Cerrar">
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
              <path d="M18.3 5.71L12 12.01l-6.3-6.3-1.4 1.41 6.3 6.29-6.3 6.3 1.4 1.41 6.3-6.3 6.3 6.3 1.41-1.41-6.3-6.3 6.3-6.29z" />
            </svg>
          </button>
        </div>

        <div className="px-6 pt-6 pb-2 text-center">
          <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-emerald-100">
            <svg viewBox="0 0 24 24" className="h-6 w-6 text-emerald-600" fill="currentColor">
              <path d="M9 16.2l-3.5-3.5-1.4 1.4L9 19 20.3 7.7l-1.4-1.4z" />
            </svg>
          </div>
          <p className="text-slate-700">
            ¡Espacio <strong>{slug}</strong> creado! Para gestionar tus eventos, vinculá tu cuenta de Google y quedá como <strong>organizador oficial</strong>.
          </p>

          <div className="mt-5 rounded-lg border bg-slate-50 p-3 text-left">
            <div className="text-xs text-slate-500">URL de tus eventos</div>
            <div className="mt-1 flex items-center justify-between gap-2">
              <code className="rounded bg-white px-2 py-1 text-sm text-slate-800 border">{salonUrl}</code>
              <button onClick={copy} className="rounded border px-3 py-1.5 text-sm hover:bg-white">Copiar</button>
            </div>
          </div>

          <div className="mt-5 grid gap-2 sm:grid-cols-2">
            {claimUrl ? (
              <a
                ref={primaryBtnRef}
                href={claimUrl}
                className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2.5 font-semibold text-white hover:bg-blue-700"
              >
                Vincular con Google
              </a>
            ) : (
              <button
                ref={primaryBtnRef}
                onClick={onGoToSalon}
                className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2.5 font-semibold text-white hover:bg-blue-700"
              >
                Ir a mis eventos
              </button>
            )}
            <button
              onClick={onGoToSalon}
              className="inline-flex items-center justify-center rounded-md border px-4 py-2.5 hover:bg-slate-50"
            >
              Ir a mis eventos
            </button>
          </div>

          <button onClick={onClose} className="mt-4 text-sm text-slate-500 hover:text-slate-700">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimSalonModal;
